// SIWS CUSTOM (2026-05-15): Calendar imprint — exposes per-line_item.properties
// helpers for calendars-picker.js to attach on /cart/add.js. Replaces the
// retired cart.attributes flow: no SSR pre-fill, no exact_repeat.

'use strict';

/* SIWS CALENDAR IMPRINT PERSISTENCE (Eddy's spec, 2026-05-16):
   replaces the previous "clear input after ATC" behavior with
   localStorage-based persistence. The dealer types their imprint
   text once and it survives across calendar PDP navigation and page
   reloads, so they don't retype for every calendar they browse. ATC
   still freezes the imprint as line item properties at the moment of
   ATC — that behavior is unchanged; cart line items are immutable
   post-ATC regardless of what happens in the input field afterward.
   v2 candidate: customer.metafield-based persistence for cross-device,
   post-login. */

(function () {
  const panel = document.querySelector('[data-siws-imprint]');
  if (!panel) return;

  const inputs = Array.from(panel.querySelectorAll('[data-imprint-line]'));
  const STORAGE_KEY = 'siws_calendar_imprint';

  function getImprintProperties() {
    const props = {};
    inputs.forEach(input => {
      props[`Imprint Line ${input.dataset.imprintLine}`] = input.value;
    });
    return props;
  }

  function resetImprintForm() {
    inputs.forEach(input => { input.value = ''; });
  }

  function readStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function saveStored() {
    const snapshot = {};
    let anyNonEmpty = false;
    inputs.forEach(input => {
      const v = input.value;
      snapshot[input.dataset.imprintLine] = v;
      if (v.trim() !== '') anyNonEmpty = true;
    });
    try {
      if (anyNonEmpty) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      /* localStorage disabled (Safari private mode, quota exceeded) — silent no-op. */
    }
  }

  // Prefill on load: only when ALL inputs are empty (don't trample partial typing
  // on PDPs where the dealer has already started entering values before script load).
  const allEmpty = inputs.every(input => input.value === '');
  if (allEmpty) {
    const stored = readStored();
    if (stored) {
      inputs.forEach(input => {
        const v = stored[input.dataset.imprintLine];
        if (typeof v === 'string' && v !== '') {
          input.value = v;
          // Dispatch an input event so any future downstream UI (validation,
          // ATC-state binding, summary readers) reflects the prefilled value.
          // Currently no downstream consumers — defensive for future binding.
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }
  }

  // Persist on blur — captures the value after the dealer finishes typing each line.
  inputs.forEach(input => {
    input.addEventListener('blur', saveStored);
  });

  window.SIWS = window.SIWS || {};
  window.SIWS.calendarImprint = { getImprintProperties, resetImprintForm };
})();
